import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {useNavigate, useParams} from "react-router-dom";
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Dropdown} from "primereact/dropdown";
import {InputNumber} from "primereact/inputnumber";
import {BlockUI} from "primereact/blockui";
import FormLocker from "../../util/FormLocker";
import {Calendar} from "primereact/calendar";
import {Dialog} from "primereact/dialog";
import {ConfirmDialog} from "primereact/confirmdialog";
import {ProgressBar} from "primereact/progressbar";
import {InputMask} from "primereact/inputmask";
import {Accordion, AccordionTab} from 'primereact/accordion';
import {OverlayPanel} from 'primereact/overlaypanel';
import moment from "moment";
import currencyFormatter from "currency-formatter";
import axios from "axios";
import Cookies from "js-cookie";

import HelpComponent from "../HelpComponent";
import download from "js-file-download";
import {Tooltip} from "primereact/tooltip";
import {AutoComplete} from "primereact/autocomplete";
import {Message} from "primereact/message";
import {Badge} from "primereact/badge";

const _FM_ReceiptFormComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {entity, action, id} = useParams();
  const [formData, setFormData] = useState({
    type: 'final',
    language: 'hu',
    issued_at: new Date().toISOString(),
    fulfillment_date: new Date().toISOString(),
    payment_due_at: new Date().toISOString(),
    items: []
  });
  const [newFormData, setNewFormData] = useState({});
  const [itemFormData, setItemFormData] = useState({});
  const [types, setTypes] = useState([]);
  const [reservationGroups, setReservationGroups] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [customersOrig, setCustomersOrig] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [partners, setPartners] = useState([]);
  const [paymentmethods, setPaymentmethods] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [countries, setCountries] = useState([]);
  const [operators, setOperators] = useState([]);
  const [buyerTypes, setBuyerTypes] = useState([]);
  const [vatPercents, setVatPercents] = useState([]);
  const [units, setUnits] = useState([]);
  const [folios, setFolios] = useState([]);
  const [folioFilter, setFolioFilter] = useState('');
  const [items, setItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState('');
  const [loading, setLoading] = useState(false);
  const [locking, setLocking] = useState(false);
  const op = useRef(null);
  const showFolioColumn = window.location.hash.toString().includes('#/receipt');
  const [isFolioColumnVisible, setIsFolioColumnVisible] = useState(false);
  const isFolioColumnEnabled = showFolioColumn && isFolioColumnVisible;
  const formatQuantity = (quantity) => {
    const parsedQuantity = Number(quantity);
    return Number.isInteger(parsedQuantity) ? String(parsedQuantity) : parsedQuantity.toFixed(2);
  };

  const validate = (data) => {
    let errors = {};
    if (!data.payment_method) {
      errors.payment_method = t('required_field');
    }
    if (!data.buyer_name) {
      errors.buyer_name = t('required_field');
    }
    if (!data.buyer_address_line1) {
      errors.buyer_address_line1 = t('required_field');
    }
    if (!data.buyer_country_code) {
      errors.buyer_country_code = t('required_field');
    }
    if (!data.buyer_zip) {
      errors.buyer_zip = t('required_field');
    }
    if (!data.buyer_city) {
      errors.buyer_city = t('required_field');
    }
    if (!data.buyer_type_enum) {
      errors.buyer_type_enum = t('required_field');
    }
    if (!data.buyer_email) {
      errors.buyer_email = t('required_field');
    }
    if (data.buyer_type_enum === 'company' && !data.buyer_tax_number) {
      errors.buyer_tax_number = t('required_field');
    }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if (formData && formData.id) {
      apiCall('patch', 'invoice/' + formData.id, newFormData)
        .then(response => {
          //setFormData(response.data.data);
          //setLoading(false)
          apiCall('get', 'invoice/' + response.data.data.id)
            .then(response => {
              setLoading(false)
              setFormData(response.data.data);
              if (response.data && response.data.data && response.data.data.under_edit_from && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
                setLocking(true)
              }
            })
            .catch(error => {
              window.App.toastShow('error', t('error'), error.toString(), '', error.response);
              setLoading(false)
            })
          setNewFormData({})
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderReceiptList: Math.random(),
            rerenderFolioDnd: Math.random(),
            rerenderFolioList: Math.random(),
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    } else {
      apiCall('post', 'invoice', formData)
        .then(response => {
          //setFormData(response.data.data)
          //setLoading(false)
          //setFormData(response.data.data);
          apiCall('get', 'invoice/' + response.data.data.id)
            .then(response => {
              setLoading(false)
              setFormData(response.data.data);
              if (response.data && response.data.data && response.data.data.under_edit_from && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
                setLocking(true)
              }
            })
            .catch(error => {
              window.App.toastShow('error', t('error'), error.toString(), '', error.response);
              setLoading(false)
            })
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderReceiptList: Math.random(),
            rerenderFolioDnd: Math.random(),
            rerenderFolioList: Math.random(),
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
            setTimeout(() => {
              let _params = '?'
              Object.entries(window.App.urlVars()).map(([key, value]) => {
                _params += key + '=' + value + '&'
              })
              _params += 'invoiceId=' + response.data.data.id
              if (window.location.hash.toString().includes('#/receipt')) {
                navigate('/receipt/' + action + '/' + id)
              }
              if (window.location.hash.toString().includes('#/folio/')) {
                if (window.location.hash.toString().includes('#/folio/manage')) {
                  navigate('/folio/manage' + _params)
                } else {
                  navigate('/folio/' + action + '/' + id)
                }
              }
              if (window.location.hash.toString().includes('#/control-panel')) {
                navigate('/control-panel?manage=folio&folioIds=' + window.App.urlVars().folioIds + _params)
              }
              if (window.location.hash.toString().includes('#/reservation') && window.App.urlVars().manage === 'folio') {
                navigate('/reservation/' + action + '/' + id + '?manage=folio&folioIds=' + window.App.urlVars().folioIds + _params)
              }
              if (window.location.hash.toString().includes('#/reservation') && window.App.urlVars().create === 'receipt') {
                navigate('/reservation/' + action + '/' + id)
              }
              if (window.location.hash.toString().includes('#/calendar') && window.App.urlVars().manage === 'folio') {
                navigate('/calendar/' + action + '/' + id + '?manage=folio&folioIds=' + window.App.urlVars().folioIds + _params)
              }
              if (window.location.hash.toString().includes('#/calendar') && window.App.urlVars().create === 'receipt') {
                navigate('/calendar/' + action + '/' + id)
              }
              if (window.location.hash.toString().includes('#/customer') && window.App.urlVars().manage === 'folio') {
                navigate('/customer/' + action + '/' + id + '?manage=folio&folioIds=' + window.App.urlVars().folioIds + _params)
              }
              if (window.location.hash.toString().includes('#/customer') && window.App.urlVars().create === 'receipt') {
                navigate('/customer/' + action + '/' + id)
              }
              window.App.setState({
                rerenderFolioDnd: Math.random(),
                rerenderFolioList: Math.random(),
              })
            }, 500)
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  FormLocker(() => {
    if (formData && formData.id && formData._class_name) {
      window.App.formLock(formData._class_name, formData.id)
    }
  }, 1000);

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
  }

  useEffect(() => {
    apiCall('get', 'dictionary/invoice-type')
      .then(response => {
        let _types = []
        response.data.data.map((type, index) => {
          if (type.key !== 'CANCEL') {
            _types.push(type)
          }
          setTypes(_types)
        })
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', 'dictionary/currency')
      .then(response => {
        const allCurrencies = response.data.data;
        const prioritizedCurrencies = JSON.parse(process.env.REACT_APP_PRIORITIZEDCURRENCIES || "[]");
        const sortedCurrencies = [
          ...allCurrencies.filter((currency) => prioritizedCurrencies.includes(currency.code)),
          ...allCurrencies.filter((currency) => !prioritizedCurrencies.includes(currency.code)),
        ];
        setCurrencies(sortedCurrencies);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', 'dictionary/country')
      .then(response => {
        const allCountries = response.data.data;
        const prioritizedCountries = JSON.parse(process.env.REACT_APP_PRIORITIZEDCOUNTRIES || "[]");
        const sortedCountries = [
          ...allCountries.filter((country) => prioritizedCountries.includes(country.code)),
          ...allCountries.filter((country) => !prioritizedCountries.includes(country.code)),
        ];
        setCountries(sortedCountries);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', 'reservation-group')
      .then(response => {
        setReservationGroups(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', 'payment-method')
      .then(response => {
        setPaymentmethods(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', 'customer')
      .then(response => {
        let _customers = []
        response.data.data.items.map((customer) => {
          if (customer.firstname && customer.zip_code && customer.address) {
            _customers.push({
              id: customer.id,
              name: customer.lastname + ' ' + customer.firstname + ' - ' + customer.zip_code + ' ' + customer.address,
              original: customer
            })
          }
          if (customer.firstname && !customer.zip_code && !customer.address) {
            _customers.push({
              id: customer.id,
              name: customer.firstname,
              original: customer
            })
          }
          if (!customer.firstname && !customer.zip_code && !customer.address) {
            _customers.push({
              id: customer.id,
              name: customer.id,
              original: customer
            })
          }
        })
        setCustomers(_customers);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', 'vat-group')
      .then(response => {
        setVatPercents(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', 'dictionary/service-unit')
      .then(response => {
        setUnits(response.data.data);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', 'dictionary/buyer-type')
      .then(response => {
        setBuyerTypes(response.data.data);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if (!window.App.urlVars().folioItemIds) {
      apiCall('get', 'folio')
        .then(response => {
          setFolios(response.data.data.items);
          apiCall('get', 'folio-item')
            .then(response => {
              setItems(response.data.data.items);
              setLoading(false)
            })
            .catch(error => {
              setLoading(false)
              window.App.toastShow('error', t('error'), error.toString(), '', error.response);
            })
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
    if (window.App.urlVars().reservationGroupId) {
      apiCall('get', 'folio?search[reservation_group][operator]=%3D&search[reservation_group][value]=' + window.App.urlVars().reservationGroupId)
        .then(response => {
          setFolios(response.data.data.items);
          apiCall('get', 'folio-item?search[reservation_group]=' + window.App.urlVars().reservationGroupId)
            .then(response => {
              setItems(response.data.data.items);
              setLoading(false)
            })
            .catch(error => {
              setLoading(false)
              window.App.toastShow('error', t('error'), error.toString(), '', error.response);
            })
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
    if ((window.App.urlVars().invoiceId || id) && !window.App.urlVars().create) {
      setLoading(true)
      apiCall('get', 'invoice/' + (window.App.urlVars().invoiceId ?? id))
        .then(response => {
          setLoading(false)
          setFormData(() => response.data.data);
          if (response.data && response.data.data && response.data.data.under_edit_from && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
            setLocking(true)
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
    if (!id) {
      apiCall('get', 'operator-data')
        .then(response => {
          setOperators(response.data.data.items);
          if (response.data.data.items && response.data.data.items[0]) {
            setFormData(prev => {
              const operator = response.data.data?.items?.[0];
              return {
                ...prev,
                operator_data: operator?.id,
                seller_name: operator?.company_name,
                seller_address_line1: operator?.street_and_house_number,
                seller_country_code: 'HU',
                seller_city: operator?.registered_office_city,
                seller_zip: operator?.zip_code,
                seller_tax_number: operator?.tax_number,
              };
            });
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }, [window.App.state.rerenderReceiptForm])

  useEffect(() => {
    if (entity !== 'receipt') {
      apiCall('get', 'operator-data')
        .then(response => {
          setOperators(response.data.data.items);
          if (response.data.data.items && response.data.data.items[0]) {
            setFormData(prev => {
              const operator = response.data.data?.items?.[0];
              return {
                ...prev,
                operator_data: operator?.id,
                seller_name: operator?.company_name,
                seller_address_line1: operator?.street_and_house_number,
                seller_country_code: 'HU',
                seller_city: operator?.registered_office_city,
                seller_zip: operator?.zip_code,
                seller_tax_number: operator?.tax_number,
              };
            });
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
    if (formData.items && formData.items[0]) {
      formData.items.map((item) => {
        if (document.getElementById('folio-item' + item.id)) {
          document.getElementById('folio-item' + item.id).classList.add('folio-item-oninvoice-true')
        }
      })
    }
  }, [formData.items])

  useEffect(() => {
    if (formData.items && formData.items[0] && items && items[0]) {
      formData.items.map((item) => {
        if (document.getElementById('folio-item' + item.id)) {
          document.getElementById('folio-item' + item.id).classList.add('folio-item-oninvoice-true')
        }
      })
    }
  }, [items])

  useEffect(() => {
    if (window.App.urlVars().reservationId && formData.operator_data) {
      apiCall('get', 'reservation/' + window.App.urlVars().reservationId)
        .then(response => {
          if (response.data.data?.reservation_group.default_billing_data) {
            setFormData({
              ...formData,
              buyer_name: response.data.data?.reservation_group.default_billing_data.name_or_company_name,
              buyer_tax_number: response.data.data?.reservation_group.default_billing_data.vat_number,
              buyer_email: response.data.data?.reservation_group.default_billing_data.email,
              buyer_address_line1: response.data.data?.reservation_group.default_billing_data.street_and_number,
              buyer_city: response.data.data?.reservation_group.default_billing_data.city,
              buyer_zip: response.data.data?.reservation_group.default_billing_data.zip_code,
              buyer_country_code: response.data.data?.reservation_group.default_billing_data.country,
            })
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }, [formData.operator_data])

  useEffect(() => {
    if (!paymentmethods[0] || formData.payment_method) return;
    const defaultPaymentMethodId = paymentmethods[0].id;
    setFormData((prev) => ({
      ...prev,
      payment_method: defaultPaymentMethodId
    }));
    setNewFormData((prev) => ({
      ...prev,
      payment_method: defaultPaymentMethodId
    }));
  }, [paymentmethods, formData.payment_method]);

  useEffect(() => {
    if (!buyerTypes[0] || formData.buyer_type_enum) return;
    const defaultBuyerType = buyerTypes[0].value;
    setFormData((prev) => ({
      ...prev,
      buyer_type_enum: defaultBuyerType
    }));
    setNewFormData((prev) => ({
      ...prev,
      buyer_type_enum: defaultBuyerType
    }));
  }, [buyerTypes, formData.buyer_type_enum]);

  useEffect(() => {
    if (!countries[0] || formData.buyer_country_code) return;
    const defaultBuyerCountry = countries[0].code;
    setFormData((prev) => ({
      ...prev,
      buyer_country_code: defaultBuyerCountry
    }));
    setNewFormData((prev) => ({
      ...prev,
      buyer_country_code: defaultBuyerCountry
    }));
  }, [countries, formData.buyer_country_code]);

  useEffect(() => {
    if (formData.items && !formData.items[0]) {
      setLoading(true)
      let _currency = ''
      if (window.App.urlVars().folioIds) {
        apiCall('get', 'folio/' + window.App.urlVars().folioIds)
          .then(response => {
            // if (response.data.data && response.data.data.accommodation && response.data.data.accommodation.currency_code) {
            //   _currency = response.data.data.accommodation.currency_code
            // } else {
            _currency = response.data.data.currency
            // }
            if (response.data.data.customer) {
              setFormData(prev => ({
                ...prev,
                buyer_name: `${response.data.data?.customer?.lastname ?? ''} ${response.data.data?.customer?.firstname ?? ''}`.trim(),
                buyer_address_line1: response.data.data?.customer?.address,
                buyer_city: response.data.data?.reservation_group?.default_billing_data?.city,
                buyer_zip: response.data.data?.customer?.zip_code,
                buyer_country_code: response.data.data?.customer?.residence_country?.toUpperCase(),
              }));
            }
            if (response.data.data.billing_data) {
              setFormData(prev => ({
                ...prev,
                buyer_name: response.data.data?.billing_data.name_or_company_name,
                buyer_tax_number: response.data.data?.billing_data.vat_number,
                buyer_email: response.data.data?.billing_data.email,
                buyer_address_line1: response.data.data?.billing_data.street_and_number,
                buyer_city: response.data.data?.billing_data.city,
                buyer_zip: response.data.data?.billing_data.zip_code,
                buyer_country_code: response.data.data?.billing_data.country,
              }));
            }
            if (response.data.data.billing_data?.vat_number) {
              setFormData(prev => ({
                ...prev,
                buyer_type_enum: "company"
              }));
            } else {
              setFormData(prev => ({
                ...prev,
                buyer_type_enum: "individual"
              }));
            }
            setLoading(false)
          })
          .catch(error => {
            setLoading(false)
          })
      }
      if (window.App.urlVars().folioItemIds && window.App.urlVars().folioItemIds[0]) {
        setTimeout(() => {
          apiCall('get', 'folio-item')
            .then(response => {
              let _itemsToSave = []
              let _items = response.data.data.items
              const _folioItems = window.App.urlVars().folioItemIds.split(",");
              _folioItems.forEach((item) => {
                let _item = _items.find(item_ => item_.id === Number(item))
                _itemsToSave.push({
                  id: _item.id,
                  name: _item.label || _item.name || _item?.service?.name,
                  quantity: _item.quantity,
                  unit: _item?.service?.unit || _item.unit,
                  unit_net_amount: _item.unit_net_amount,
                  vat_percent: _item.vat_percent,
                  folio_item: _item.id
                })
              });
              setFormData(prev => ({
                ...prev,
                currency: _currency,
                items: [
                  ...(prev.items ?? []),
                  ..._itemsToSave,
                ],
              }));
              setLoading(false)
            })
            .catch(error => {
              setLoading(false)
              window.App.toastShow('error', t('error'), error.toString(), '', error.response);
            })
        }, 2000)
      }
    }
  }, [window.App.urlVars().folioIds, window.App.urlVars().folioItemIds])

  return (
    <div className={"_FM_ReceiptPage"}>
      {entity === 'receipt' &&
        <div className={"p-grid p-my-3"}>
          <div className={"p-col-12 p-lg-4 p-py-0 p-col-align-center"}>
            <h2 className={"p-my-0"}>
              {t('receipt_form')}
              <Badge
                value={
                  (formData.status || 'draft') === 'draft'
                    ? t('receipt_status_draft')
                    : (formData.status || 'draft') === 'issued'
                      ? (formData.type === 'proforma'
                        ? t('receipt_status_proforma')
                        : t('receipt_status_issued'))
                      : (formData.status || 'draft') === 'cancelled'
                        ? t('receipt_status_cancelled')
                        : t('receipt_status_draft')
                }
                style={{
                  marginLeft: '10px',
                  position: 'relative',
                  top: '-4px',
                  backgroundColor:
                    (formData.status || 'draft') === 'draft'
                      ? '#ffb027'
                      : (formData.status || 'draft') === 'issued'
                        ? '#0abb87'
                        : (formData.status || 'draft') === 'cancelled'
                          ? '#ff7f7f'
                          : '#ffb027',
                  color: '#fff'
                }}
              />
            </h2>
          </div>
          <div className={"p-col-12 p-lg-8 p-py-0 p-text-right p-col-align-center"}>
            <Button type="button"
                    icon={"pi pi-times"}
                    onClick={() => {
                      if (entity === 'receipt') {
                        navigate('/receipt')
                      }
                    }}
                    className="p-button-secondary close p-ml-2">
            </Button>
          </div>
        </div>
      }
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: 'fixed', top: 0, zIndex: 9}}></ProgressBar>
      }
      <div className={"p-grid"}>
        {isFolioColumnEnabled &&
          <div className={"p-col-12 p-md-4"}>
            <Panel className={"p-mt-3"}>
              <div className={"p-grid"}>
                <div className={"p-col p-col-align-center"}>
                  <h3 className={"p-my-0"}>
                    {t('folios')}
                  </h3>
                </div>
                <div className={"p-col p-col-align-center p-text-right"}>
                  <InputText id="search"
                             placeholder={t('search')}
                             onChange={(e) => {
                               setFolioFilter(e.target.value)
                               clearTimeout(window.searchTimeout)
                               window.searchTimeout = setTimeout(function () {
                                 setLoading(true)
                                 apiCall('get', 'folio?search[customer_name]=' + e.target.value)
                                   .then(response => {
                                     setFolios(response.data.data.items);
                                     apiCall('get', 'folio-item')
                                       .then(response => {
                                         setItems(response.data.data.items);
                                         setLoading(false)
                                       })
                                       .catch(error => {
                                         setLoading(false)
                                         window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                       })
                                   })
                                   .catch(error => {
                                     setLoading(false)
                                     window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                   })
                               }, 1000)
                             }}
                             value={folioFilter}
                             className={"w-100"}
                  />
                </div>
              </div>
              {folios && folios[0] &&
                <>
                  {folios.map((folio, index) => {
                    let _items = items.filter(item => item.folio.id === folio.id)
                    return (
                      <div className={"p-grid"} key={index}>
                        <div className={"p-col"}>
                          <strong style={{cursor: 'pointer'}}
                                  onClick={(e) => {
                                    if (formData.items && formData.items[0] && formData.currency && folio.currency != formData.currency) {
                                      window.App.toastShow('warn', t('warning'), t('folio_item_currency_not_match_receipt_currency'), '',);
                                    } else {
                                      window.App.setState({[`confirmReceipt${folio.id}`]: true})
                                    }
                                  }}
                                  className={"p-d-block p-mb-2"}>
                            <span className={"tooltip-" + folio.id}>
                              {folio.name}
                            </span>
                            <Tooltip target={".tooltip-" + folio.id}>
                              {t('folio')}: {folio.id}
                            </Tooltip>
                            <span style={{
                              float: "right",
                              fontWeight: "normal"
                            }}>{moment.utc(folio.created_at_snapshot).local().format(t('YYYY-MM-DD'))}</span>
                          </strong>
                          <ConfirmDialog group="declarative" visible={window.App.state[`confirmReceipt${folio.id}`]}
                                         acceptLabel={t('yes')} rejectLabel={t('no')}
                                         onHide={() => {
                                           window.App.setState({[`confirmReceipt${folio.id}`]: false})
                                         }}
                                         message={t('confirm_add_receipt_items_message')}
                                         header={t('confirm_add_receipt_items')} icon="pi pi-exclamation-triangle"
                                         accept={() => {
                                           let _items = items.filter(item => item.folio.id === folio.id)
                                           let _itemsToSave = []
                                           _items.map((item, index) => {
                                             if (!item.on_invoice) {
                                               _itemsToSave.push({
                                                 id: item.id,
                                                 name: item.label || item.name || item?.service?.name,
                                                 quantity: item.quantity,
                                                 unit: item?.service?.unit || item.unit,
                                                 unit_net_amount: item.unit_net_amount,
                                                 vat_percent: item.vat_percent,
                                                 folio_item: item.id
                                               })
                                               document.getElementById('folio-item' + item.id).classList.add('folio-item-oninvoice-true')
                                             } else {
                                               window.App.toastShow('warn', t('warning'), t('folio_items_already_invoiced'), '',);
                                             }
                                           })
                                           setFormData({
                                             ...formData,
                                             currency: folio.currency,
                                             items: [
                                               ...formData.items,
                                               ..._itemsToSave
                                             ]
                                           })
                                           setNewFormData({
                                             ...newFormData,
                                             items: [
                                               ...formData.items,
                                               ..._itemsToSave
                                             ]
                                           })
                                         }}
                                         reject={() => {
                                           window.App.setState({[`confirmReceipt${folio.id}`]: false})
                                         }}/>
                          {_items && _items[0] &&
                            <>
                              {_items.map((item, index) => {
                                return (
                                  <div id={"folio-item" + item.id}
                                       style={{cursor: 'pointer'}}
                                       className={"p-grid p-mt-1 folio-item-invoiced-" + item.on_invoice}
                                       onClick={(e) => {
                                         if (item.on_invoice) {
                                           op.current.toggle(e)
                                           window.App.toastShow('warn', t('warning'), t('folio_item_already_invoiced'), '',);
                                         } else {
                                           if (formData.items && formData.items[0] && formData.currency && item.currency != formData.currency) {
                                             window.App.toastShow('warn', t('warning'), t('folio_item_currency_not_match_receipt_currency'), '',);
                                           } else {
                                             setSelectedItem(item.id)
                                             setItemFormData({
                                               id: item.id,
                                               name: item.label || item.name || item?.service?.name,
                                               quantity: item.quantity,
                                               unit: item?.service?.unit || item.unit,
                                               unit_net_amount: item.unit_net_amount,
                                               vat_percent: item.vat_percent,
                                               folio_item: item.id
                                             })
                                             setFormData({
                                               ...formData,
                                               currency: item.currency,
                                             })
                                             if (window.location.hash.toString().includes('#/reservation')) {
                                               navigate('/reservation/' + action + '/' + id + '?create=invoice&add=receiptItem&folioItemId=' + item.id)
                                             } else if (action === 'create') {
                                               navigate('/receipt/' + action + '?create=receiptItem&folioItemId=' + item.id)
                                             } else if (action === 'update') {
                                               navigate('/receipt/' + action + '/' + id + '?create=receiptItem&folioItemId=' + item.id)
                                             }
                                           }
                                         }
                                       }}
                                  >
                                    <div className={"p-col"}>
                                      {item.current_invoice_id ? (
                                        <>
                                          <i className={"pi pi-window-maximize"}
                                             onClick={(e) => op.current.toggle(e)}
                                          ></i>
                                          &nbsp;
                                          <OverlayPanel ref={op} style={{maxWidth: '250px'}}>
                                            <div className={"p-grid p-p-0 p-m-0"}>
                                              <div className={"p-col-8 p-col-align-center p-p-0 p-m-0"}
                                                   onClick={(e) => {
                                                     e.stopPropagation();
                                                     navigate('/receipt/')
                                                     setTimeout(() => {
                                                       navigate('/receipt/update/' + item.current_invoice_id)
                                                     }, 500)
                                                   }}
                                              >
                                          <span style={{textDecoration: 'underline', cursor: 'pointer'}}>
                                            {item.current_invoice_third_party_id || t('receipt_show')}
                                          </span>
                                              </div>
                                              <div className={"p-col p-text-right p-col-align-center p-p-0 p-m-0"}>
                                                <Button icon="pi pi-download"
                                                        className="p-button-sm p-button-secondary"
                                                        tooltip={t('download')}
                                                        disabled={!item.pdf_url}
                                                        loading={loading}
                                                        tooltipOptions={{position: 'left'}}
                                                        onClick={() => {
                                                          window.open(item.pdf_url, '_blank', 'noopener,noreferrer');
                                                        }}
                                                />
                                              </div>
                                            </div>
                                          </OverlayPanel>
                                        </>
                                      ) : (
                                        <>
                                        </>
                                      )}
                                      {item.label || item.name || item?.service?.name}
                                    </div>
                                    <div className={"p-col-2 p-text-right"}>
                                      {currencyFormatter.format(
                                        item.gross_amount || 0, {
                                          precision: t('currency_precision'),
                                          symbol: t('currency_symbol'),
                                          decimal: t('currency_decimal'),
                                          thousand: t('currency_thousand'),
                                        }
                                      )} {item.currency}
                                    </div>
                                  </div>
                                )
                              })}
                            </>
                          }
                          <hr/>
                        </div>
                      </div>
                    )
                  })}
                </>
              }
            </Panel>
          </div>
        }
        <div className={isFolioColumnEnabled ? "p-col-12 p-md-8" : "p-col-12"} style={{position: 'relative'}}>
          <BlockUI blocked={locking} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i className="pi pi-exclamation-triangle blocked-ui-message-icon" aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
            <Form onSubmit={onSubmit} initialValues={formData}
                  validate={validate} render={({handleSubmit}) => (
              <form onSubmit={handleSubmit} className="">
                <Panel className={"p-mt-3"}>
                  <div className={"p-grid"}>
                    {showFolioColumn &&
                      <div className={"p-col-12 p-lg-1 p-col-align-center"} style={{maxWidth: '36px'}}>
                        <Button
                          type="button"
                          icon={isFolioColumnEnabled ? "pi pi-ellipsis-v" : "pi pi-ellipsis-h"}
                          className="p-button-info p-button-sm p-button-outlined"
                          onClick={() => setIsFolioColumnVisible(!isFolioColumnVisible)}
                          tooltip={isFolioColumnVisible ? t('hide_folio_items') : t('show_folio_items')}
                          tooltipOptions={{position: 'left'}}
                        />
                      </div>
                    }
                    <div className={"p-col-12 p-lg-4 p-col-align-center"}>
                      <h2 className={"p-m-0"}>
                        {t('receipt_form')}
                        <Badge
                          value={
                            (formData.status || 'draft') === 'draft'
                              ? t('receipt_status_draft')
                              : (formData.status || 'draft') === 'issued'
                                ? (formData.type === 'proforma'
                                  ? t('receipt_status_proforma')
                                  : t('receipt_status_issued'))
                                : (formData.status || 'draft') === 'cancelled'
                                  ? t('receipt_status_cancelled')
                                  : t('receipt_status_draft')
                          }
                          style={{
                            marginLeft: '10px',
                            position: 'relative',
                            top: '-4px',
                            backgroundColor:
                              (formData.status || 'draft') === 'draft'
                                ? '#ffb027'
                                : (formData.status || 'draft') === 'issued'
                                  ? '#0abb87'
                                  : (formData.status || 'draft') === 'cancelled'
                                    ? '#ff7f7f'
                                    : '#ffb027',
                            color: '#fff'
                          }}
                        />
                        {(formData.paid_at && formData.paid_at !== null) ? (
                          <Badge value={t('paid')} style={{backgroundColor: '#0abb87', color: '#fff', position: 'relative',
                            top: '-4px'}}
                                 className={"p-ml-2"}/>
                        ):(
                          <Badge value={t('unpaid')} style={{backgroundColor: '#ffb027', color: '#fff', position: 'relative',
                            top: '-4px'}}
                                 className={"p-ml-2"}/>
                        )}
                      </h2>
                    </div>
                    <div className={"p-col p-text-right p-col-align-center"}>
                      {formData?.type === 'proforma' && formData?.status === 'issued' && formData?.paid_at && formData?.paid_at === null ? (
                        <Button icon="pi pi-check" className="p-button-success p-ml-2"
                                label={t('mark_as_paid')}
                                loading={loading}
                                onClick={() => {
                                  axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "invoice/" + formData.id + "/mark-paid",
                                    {},
                                    {
                                      params: {},
                                      headers: {
                                        'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                        "Sys-name": Cookies.get("instanceId"),
                                        "Preferred-locale": Cookies.get("language"),
                                        'Content-Type': 'multipart/form-data'
                                      }
                                    })
                                    .then(response => {
                                      window.App.setState({
                                        rerenderReceiptList: Math.random(),
                                      })
                                    })
                                    .catch(error => {
                                      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                    })
                                }}
                        />
                      ):(
                        <Button icon="pi pi-check" className="p-button-success p-ml-2"
                                label={t('mark_as_paid')}
                                disabled
                        />
                      )}
                      {formData?.billing_integration && formData?.billing_integration !== 'none' ? (
                        <Button icon="pi pi-download" className="p-button-md p-button-secondary p-ml-2"
                                label={t('download')}
                                disabled={!formData.pdf_url}
                                loading={loading}
                                onClick={() => {
                                  if (formData?.billing_integration === 'Billingo') {
                                    window.open(formData.pdf_url, '_blank', 'noopener,noreferrer');
                                  }
                                  if (formData?.billing_integration === 'számlázz.hu') {
                                    axios.get(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + 'billing/invoice/' + formData.id + '/download-pdf',
                                      {
                                        responseType: 'blob',
                                        params: {},
                                        headers: {
                                          'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                          "Sys-name": Cookies.get("instanceId"),
                                          "Preferred-locale": Cookies.get("language"),
                                        }
                                      })
                                      .then(response => {
                                        window.App.toastShow('success', t('success'), response.data.message)
                                        download(response.data, formData.third_party_service_id + '.pdf')
                                      })
                                      .catch(error => {
                                        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                      })
                                  }
                                }}
                        />
                      ) : (
                        <Button icon="pi pi-download" className="p-button-md p-button-secondary p-ml-2"
                                label={t('download')}
                                disabled
                                loading={loading}
                        />
                      )}
                      {formData.id && formData.status === 'draft' && formData.items && formData.items[0] ? (
                        <Button icon="pi pi-sync" className="p-button-md p-button-success p-ml-2"
                                label={t('sync_receipt_and_save')}
                                loading={loading}
                                disabled={
                                  !formData.billing_integration ||
                                  formData.billing_integration?.length == 0 ||
                                  formData.billing_integration === 'none'
                                }
                                onClick={() => {
                                  if (formData?.billing_integration === 'számlázz.hu') {
                                    setLoading(true);
                                    axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "billing/invoice/" + formData.id + "/sync-szamlazzhu",
                                      formData,
                                      {
                                        params: {},
                                        headers: {
                                          'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                          "Sys-name": Cookies.get("instanceId"),
                                          "Preferred-locale": Cookies.get("language")
                                        }
                                      })
                                      .then(response => {
                                        window.App.toastShow('success', t('success'), response.data.message)
                                        window.App.setState({
                                          rerenderReceiptList: Math.random(),
                                          rerenderFolioList: Math.random(),
                                        })
                                        apiCall('get', 'invoice/' + formData.id)
                                          .then(response => {
                                            setLoading(false)
                                            setFormData(response.data.data);
                                            if (response.data && response.data.data && response.data.data.under_edit_from && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
                                              setLocking(true)
                                            }
                                            navigate(-1)
                                          })
                                          .catch(error => {
                                            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                            setLoading(false)
                                          })
                                      })
                                      .catch(error => {
                                        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                        setLoading(false)
                                      })
                                  }
                                  if (formData?.billing_integration === 'Billingo') {
                                    setLoading(true);
                                    axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "billing/invoice/" + formData.id + "/sync-billingo",
                                      formData,
                                      {
                                        params: {},
                                        headers: {
                                          'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                          "Sys-name": Cookies.get("instanceId"),
                                          "Preferred-locale": Cookies.get("language")
                                        }
                                      })
                                      .then(response => {
                                        window.App.toastShow('success', t('success'), response.data.message)
                                        window.App.setState({
                                          rerenderReceiptList: Math.random(),
                                          rerenderFolioList: Math.random(),
                                        })
                                        apiCall('get', 'invoice/' + formData.id)
                                          .then(response => {
                                            setLoading(false)
                                            setFormData(response.data.data);
                                            if (response.data && response.data.data && response.data.data.under_edit_from && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
                                              setLocking(true)
                                            }
                                          })
                                          .catch(error => {
                                            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                            setLoading(false)
                                          })
                                      })
                                      .catch(error => {
                                        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                        setLoading(false)
                                      })
                                  }
                                }}
                        />
                      ) : (
                        <Button icon="pi pi-sync" className="p-button-md p-button-success p-ml-2 disabled"
                                label={t('sync_receipt_and_save')}
                                loading={loading}
                                onClick={() => {
                                  //window.App.customToastShow('warn', t('warning'), t('sync_receipt_not_available'));
                                }}
                        />
                      )}
                      {entity === 'receipt' &&
                        <Button type="submit" aria-label={t('save')} icon={"pi pi-save"}
                                loading={loading}
                                onClick={() => {
                                  props = {...props, closeForm: false}
                                }}
                                className="p-button-success p-ml-2"/>
                      }
                      <Button type="submit" aria-label={t('save_and_close')}
                              loading={loading}
                              onClick={() => {
                                props = {...props, closeForm: true}
                              }}
                              className="p-button-success p-ml-2">
                    <span>
                      <i className={"pi pi-save"}></i>&nbsp;&nbsp;<i className={"pi pi-backward"}></i>
                    </span>
                      </Button>
                      <Button type="button"
                              icon={"pi pi-times"}
                              onClick={() => {
                                navigate(-1)
                              }}
                              className="p-button-secondary close p-ml-2">
                      </Button>
                    </div>
                  </div>
                  {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
                  <HelpComponent type={"edit_box"}/>
                  {entity === 'receipt' &&
                    <>
                      <div className={"p-grid head"}>
                        <div className={"p-col"} style={{minWidth: '150px'}}>
                          <Field name="reservation_group" render={({input, meta}) => (
                            <div className="p-field p-fluid">
                              <HelpComponent type={"field"} field={"reservation_group"}/>
                              <label htmlFor="reservation_group"
                                     className={classNames({'p-error': isFormFieldValid(meta)})}>{t('reservation_group')}</label>
                              <span className="p-d-block">
                          <Dropdown  options={reservationGroups}
                                    filter
                                    optionLabel="public_id"
                                    optionValue="id"
                                    id={"reservation_group"}
                                    emptyMessage={t('empty_message')}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        reservation_group: e.value,
                                        customer: null
                                      })
                                      setNewFormData({
                                        ...newFormData,
                                        reservation_group: e.value,
                                        customer: null
                                      })
                                      setSelectedCustomer('')
                                    }}
                                    value={formData?.reservation_group?.id || formData.reservation_group}
                          />
                    </span>
                              {getFormErrorMessage(meta)}
                            </div>
                          )}/>
                        </div>
                        <div className={"p-col"} style={{minWidth: '150px'}}>
                          <Field name="customer" render={({input, meta}) => (
                            <div className="p-field p-fluid">
                              <HelpComponent type={"field"} field={"customer"}/>
                              <label htmlFor="customer"
                                     className={classNames({'p-error': isFormFieldValid(meta)})}>{t('customer')}</label>
                              <span className="p-d-block">
                                <AutoComplete value={selectedCustomer}
                                              id={"partner"}
                                              suggestions={customers}
                                              forceSelection
                                              dropdown
                                              completeMethod={(e) => {
                                                axios({
                                                  method: 'get',
                                                  url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST
                                                    + "customer??direction=desc&item_per_page=9999&search[firstname%2Blastname][operator]=like&search[firstname%2Blastname][value]=*"
                                                    + e.query + "*&sort=id",
                                                  params: {},
                                                  headers: {
                                                    'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                                    "Sys-name": Cookies.get("instanceId"),
                                                    "Preferred-locale": Cookies.get("language")
                                                  }
                                                })
                                                  .then(response => {
                                                    if (response.data.data.items && response.data.data.items[0]) {
                                                      setCustomersOrig(response.data.data.items)
                                                      let _customers = []
                                                      response.data.data.items.map((customer) => {
                                                        if (customer.firstname && customer.zip_code && customer.address) {
                                                          _customers.push({
                                                            id: customer.id,
                                                            name: customer.lastname + ' ' + customer.firstname + ' - ' + customer.zip_code + ' ' + customer.address,
                                                          })
                                                        }
                                                        if (customer.firstname && !customer.zip_code && !customer.address) {
                                                          _customers.push({
                                                            id: customer.id,
                                                            name: customer.firstname,
                                                          })
                                                        }
                                                        if (!customer.firstname && !customer.zip_code && !customer.address) {
                                                          _customers.push({
                                                            id: customer.id,
                                                            name: customer.id,
                                                          })
                                                        }
                                                      })
                                                      setCustomers(_customers);
                                                    } else {
                                                      setSelectedCustomer(t('no_results_found'))
                                                      setCustomers([])
                                                    }
                                                  })
                                                  .catch(error => {
                                                    window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                                  })
                                              }}
                                              field={"name"}
                                              delay="1000"
                                              placeholder={t('type_to_search')}
                                              onSelect={(e) => {
                                                let _customer = customersOrig.find(customer => customer.id === e?.value?.id)
                                                if (e.value.length > 0) {
                                                  setSelectedCustomer(e.value.replace(t('no_results_found')))
                                                } else {
                                                  setSelectedCustomer(e.value)
                                                }
                                                setFormData((prevState) => ({
                                                  ...prevState,
                                                  customer: e.value,
                                                  reservation_group: null,
                                                  buyer_name: _customer?.lastname + ' ' + _customer?.firstname,
                                                  buyer_address_line1: _customer?.address,
                                                  buyer_country_code: _customer?.residence_country?.toUpperCase(),
                                                  buyer_zip: _customer?.zip_code,
                                                  buyer_type_enum: 'individual',
                                                }));
                                                setNewFormData({
                                                  ...newFormData,
                                                  customer: e.value,
                                                  reservation_group: null
                                                })
                                              }}
                                              onChange={(e) => {
                                                setSelectedCustomer(e.value)
                                                let _customer = customersOrig.find(customer => customer.id === e?.value?.id)
                                                if (!_customer) {
                                                  _customer = {
                                                    lastname: '',
                                                    firstname: '',
                                                  }
                                                }
                                                setFormData((prevState) => ({
                                                  ...prevState,
                                                  customer: e.value,
                                                  reservation_group: null,
                                                  buyer_name: _customer?.firstname + ' ' + _customer?.lastname,
                                                  buyer_address_line1: _customer?.address,
                                                  buyer_country_code: _customer?.residence_country?.toUpperCase(),
                                                  buyer_zip: _customer?.zip_code,
                                                  buyer_type_enum: 'individual',
                                                }));
                                                setNewFormData({
                                                  ...newFormData,
                                                  customer: e.value,
                                                  reservation_group: null
                                                })
                                              }}
                                              onClear={(e) => {
                                                setSelectedCustomer(e.value)
                                                setFormData((prevState) => ({
                                                  ...prevState,
                                                  customer: null,
                                                  reservation_group: null,
                                                  buyer_name: '',
                                                  buyer_type: null,
                                                  buyer_address_line1: '',
                                                  buyer_country_code: null,
                                                  buyer_zip: '',
                                                }));
                                                setNewFormData({
                                                  ...newFormData,
                                                  customer: e.value,
                                                  reservation_group: null
                                                })
                                              }}
                                />
                                {/*<Dropdown  options={customers}*/}
                                {/*          filter*/}
                                {/*          {...input}*/}
                                {/*          optionLabel="name"*/}
                                {/*          optionValue="id"*/}
                                {/*          id={"customer"}*/}
                                {/*          emptyMessage={t('empty_message')}*/}
                                {/*          onChange={(e) => {*/}
                                {/*            let _customer = customers.find(customer => customer.id === e.value)*/}
                                {/*            setFormData({*/}
                                {/*              ...formData,*/}
                                {/*              customer: e.value,*/}
                                {/*              reservation_group: null,*/}
                                {/*              buyer_name: _customer?.original?.lastname + ' ' + _customer?.original?.firstname,*/}
                                {/*              buyer_address_line1: _customer?.original?.address,*/}
                                {/*              buyer_country_code: _customer?.original?.residence_country.toUpperCase(),*/}
                                {/*              buyer_zip: _customer?.original?.zip_code,*/}
                                {/*            })*/}
                                {/*            setNewFormData({*/}
                                {/*              ...newFormData,*/}
                                {/*              customer: e.value,*/}
                                {/*              reservation_group: null*/}
                                {/*            })*/}
                                {/*            setTimeout(() => {*/}
                                {/*              validate(formData)*/}
                                {/*            }, 1000)*/}
                                {/*          }}*/}
                                {/*          value={formData?.customer?.id || formData.customer}*/}
                                {/*/>*/}
                              </span>
                              {getFormErrorMessage(meta)}
                            </div>
                          )}/>
                        </div>
                      </div>
                      <hr className={"p-mt-0 p-mb-5"}/>
                    </>
                  }
                  <div className={"p-grid col-borders"}>
                    <div className={"p-col-12 p-lg-6 col-border-right"}>
                      <div className={"p-grid"}>
                        <div className={"p-col-12 p-lg-6 p-col-align-center"}>
                          <h3 className={"p-p-0 p-mb-0 p-mt-2"}>
                            {t('head_data')}
                          </h3>
                        </div>
                        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-right"}>

                        </div>
                      </div>
                      <div className={"p-grid"}>
                        <div className={"p-col-12 p-lg-2"}>
                          <Field name="type" render={({input, meta}) => (
                            <div className="p-field p-fluid">
                              <HelpComponent type={"field"} field={"type"}/>
                              <label htmlFor="type"
                                     className={classNames({'p-error': isFormFieldValid(meta)})}>{t('type')}</label>
                              <span className="p-d-block">
                          <Dropdown  options={types}
                                    filter
                                    disabled
                                    optionLabel={(option) => window.App.getTranslatedLabel(option.value)}
                                    optionValue="value"
                                    id={"type"}
                                    emptyMessage={t('empty_message')}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        type: e.value
                                      })
                                      setNewFormData({
                                        ...newFormData,
                                        type: e.value
                                      })
                                    }}
                                    value={formData?.type?.id || formData.type}
                          />
                    </span>
                              {getFormErrorMessage(meta)}
                            </div>
                          )}/>
                        </div>
                        <div className={"p-col-12 p-lg-2"}>
                          <Field name="language" render={({input, meta}) => (
                            <div className="p-field p-fluid">
                              <HelpComponent type={"field"} field={"type"}/>
                              <label htmlFor="language"
                                     className={classNames({'p-error': isFormFieldValid(meta)})}>{t('language')}</label>
                              <span className="p-d-block">
                          <Dropdown  options={[
                            {label: 'HU', value: 'hu'},
                            {label: 'EN', value: 'en'},
                          ]}
                                    filter
                                    optionLabel="label"
                                    optionValue="value"
                                    id={"language"}
                                    emptyMessage={t('empty_message')}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        language: e.value
                                      })
                                      setNewFormData({
                                        ...newFormData,
                                        language: e.value
                                      })
                                    }}
                                    value={formData.language}
                          />
                    </span>
                              {getFormErrorMessage(meta)}
                            </div>
                          )}/>
                        </div>
                        <div className={"p-col-12 p-lg-4"}>
                          <Field name="payment_method" render={({input, meta}) => (
                            <div className="p-field p-fluid">
                              <HelpComponent type={"field"} field={"payment_method"}/>
                              <label htmlFor="payment_method"
                                     className={classNames({'p-error': isFormFieldValid(meta)})}>{t('payment_method')}</label>
                              <span className="p-d-block">
                          <Dropdown  options={paymentmethods}
                                    filter
                                    optionLabel={(option) => window.App.getTranslatedLabel(option.name)?.replaceAll('_', ' ')}
                                    optionValue="id"
                                    id={"payment_method"}
                                    emptyMessage={t('empty_message')}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        payment_method: e.value
                                      })
                                      setNewFormData({
                                        ...newFormData,
                                        payment_method: e.value
                                      })
                                    }}
                                    value={formData?.payment_method?.id || formData.payment_method}
                          />
                    </span>
                              {getFormErrorMessage(meta)}
                            </div>
                          )}/>
                        </div>
                        <div className={"p-col-12 p-lg-4"}>
                          <Field name="currency" render={({input, meta}) => (
                            <div className="p-field p-fluid">
                              <HelpComponent type={"field"} field={"currency"}/>
                              <label htmlFor="currency"
                                     className={classNames({'p-error': isFormFieldValid(meta)})}>{t('currency')}</label>
                              <span className="p-d-block">
                          <Dropdown  options={currencies}
                                    filter
                                    disabled
                                    optionLabel="code"
                                    optionValue="code"
                                    id={"currency"}
                                    emptyMessage={t('empty_message')}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        currency: e.value
                                      })
                                      setNewFormData({
                                        ...newFormData,
                                        currency: e.value
                                      })
                                    }}
                                    value={formData?.currency?.id || formData.currency}
                          />
                    </span>
                              {getFormErrorMessage(meta)}
                            </div>
                          )}/>
                        </div>
                        <div className={"p-col-12 p-lg-4"} style={{minWidth: '160px'}}>
                          <Field name="issued_at" render={({input, meta}) => (
                            <div className="p-field p-fluid">
                              <HelpComponent type={"field"} field={"issued_at"}/>
                              <label htmlFor="issued_at"
                                     className={classNames({'p-error': isFormFieldValid(meta)})}>{t('issued_at')}</label>
                              <span className="">
                        <div className="p-inputgroup calendar-icon-only">
                          <InputMask id={"issued_at"}
                                     mask={t('9999-99-99')}
                                     value={moment.utc(formData.issued_at).local().format(t('YYYY-MM-DD'))}
                                     onChange={(e) => {
                                       if (e.value.indexOf("_") === -1) {
                                         if (e.value === '') {
                                           e.value = null
                                         }
                                         setFormData({
                                           ...formData,
                                           issued_at: moment(e.value, 'YYYY-DD-MM').endOf('day').toISOString()
                                         })
                                         setNewFormData({
                                           ...newFormData,
                                           issued_at: moment(e.value, 'YYYY-DD-MM').endOf('day').toISOString()
                                         })
                                       }
                                     }}
                          />
                          <Calendar value={formData.issued_at ? moment(formData.issued_at).toDate() : null}
                                    locale="default"
                                    dateFormat={t('YY-MM-DD')}
                                    showIcon
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        issued_at: moment(e.value, 'YYYY-DD-MM').endOf('day').toISOString()
                                      })
                                      setNewFormData({
                                        ...newFormData,
                                        issued_at: moment(e.value, 'YYYY-DD-MM').endOf('day').toISOString()
                                      })
                                    }}/>
                        </div>
                      </span>
                              {getFormErrorMessage(meta)}
                            </div>
                          )}/>
                        </div>
                        <div className={"p-col-12 p-lg-4"} style={{minWidth: '160px'}}>
                          <Field name="fulfillment_date" render={({input, meta}) => (
                            <div className="p-field p-fluid">
                              <HelpComponent type={"field"} field={"fulfillment_date"}/>
                              <label htmlFor="fulfillment_date"
                                     className={classNames({'p-error': isFormFieldValid(meta)})}>{t('fulfillment_date')}</label>
                              <span className="">
                        <div className="p-inputgroup calendar-icon-only">
                          <InputMask id={"fulfillment_date"}
                                     mask={t('9999-99-99')}
                                     value={moment.utc(formData.fulfillment_date).local().format(t('YYYY-MM-DD'))}
                                     onChange={(e) => {
                                       if (e.value.indexOf("_") === -1) {
                                         if (e.value === '') {
                                           e.value = null
                                         }
                                         setFormData({
                                           ...formData,
                                           fulfillment_date: moment(e.value, 'YYYY-DD-MM').endOf('day').toISOString()
                                         })
                                         setNewFormData({
                                           ...newFormData,
                                           fulfillment_date: moment(e.value, 'YYYY-DD-MM').endOf('day').toISOString()
                                         })
                                       }
                                     }}
                          />
                          <Calendar
                            value={formData.fulfillment_date ? moment(formData.fulfillment_date).toDate() : null}
                            locale="default"
                            dateFormat={t('YY-MM-DD')}
                            showIcon
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                fulfillment_date: moment(e.value, 'YYYY-DD-MM').endOf('day').toISOString()
                              })
                              setNewFormData({
                                ...newFormData,
                                fulfillment_date: moment(e.value, 'YYYY-DD-MM').endOf('day').toISOString()
                              })
                            }}/>
                        </div>
                      </span>
                              {getFormErrorMessage(meta)}
                            </div>
                          )}/>
                        </div>
                        <div className={"p-col-12 p-lg-4"} style={{minWidth: '160px'}}>
                          <Field name="payment_due_at" render={({input, meta}) => (
                            <div className="p-field p-fluid">
                              <HelpComponent type={"field"} field={"payment_due_at"}/>
                              <label htmlFor="payment_due_at"
                                     className={classNames({'p-error': isFormFieldValid(meta)})}>{t('payment_due_at')}</label>
                              <span className="">
                        <div className="p-inputgroup calendar-icon-only">
                          <InputMask id={"payment_due_at"}
                                     mask={t('9999-99-99')}
                                     value={moment.utc(formData.payment_due_at).local().format(t('YYYY-MM-DD'))}
                                     onChange={(e) => {
                                       if (e.value.indexOf("_") === -1) {
                                         if (e.value === '') {
                                           e.value = null
                                         }
                                         setFormData({
                                           ...formData,
                                           payment_due_at: moment(e.value, 'YYYY-DD-MM').endOf('day').toISOString()
                                         })
                                         setNewFormData({
                                           ...newFormData,
                                           payment_due_at: moment(e.value, 'YYYY-DD-MM').endOf('day').toISOString()
                                         })
                                       }
                                     }}
                          />
                          <Calendar value={formData.payment_due_at ? moment(formData.payment_due_at).toDate() : null}
                                    locale="default"
                                    dateFormat={t('YY-MM-DD')}
                                    showIcon
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        payment_due_at: moment(e.value, 'YYYY-DD-MM').endOf('day').toISOString()
                                      })
                                      setNewFormData({
                                        ...newFormData,
                                        payment_due_at: moment(e.value, 'YYYY-DD-MM').endOf('day').toISOString()
                                      })
                                    }}/>
                        </div>
                      </span>
                              {getFormErrorMessage(meta)}
                            </div>
                          )}/>
                        </div>
                      </div>
                      <div className="p-field p-fluid p-mt-2 accordion-fake-input">
                        <label htmlFor="seller_name">{t('seller')}</label>
                        <Accordion>
                          <AccordionTab header={formData.seller_name}>
                            <div className={"p-grid"}>
                              <div className={"p-col-12 p-lg-8"}>
                                <Field name="seller_name" render={({input, meta}) => (
                                  <div className="p-field p-fluid">
                                    <HelpComponent type={"field"} field={"seller_name"}/>
                                    <label htmlFor="seller_name"
                                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('name')}</label>
                                    <span className="p-d-block">
                                    <Dropdown  options={operators}
                                              filter
                                              placeholder={formData.seller_name}
                                              optionLabel="company_name"
                                              optionValue="id"
                                              id={"customer"}
                                              emptyMessage={t('empty_message')}
                                              onChange={(e) => {
                                                let _operator = operators.find(customer => customer.id === e.value)
                                                setFormData({
                                                  ...formData,
                                                  operator_data: e.value,
                                                  seller_name: _operator?.company_name,
                                                  seller_address_line1: _operator?.street_and_house_number,
                                                  seller_country_code: 'HU',
                                                  seller_city: _operator?.registered_office_city,
                                                  seller_zip: _operator?.zip_code,
                                                  seller_tax_number: _operator?.tax_number,
                                                })
                                                setNewFormData({
                                                  ...newFormData,
                                                  operator_data: e.value,
                                                  seller_name: _operator?.company_name,
                                                  seller_address_line1: _operator?.street_and_house_number,
                                                  seller_country_code: 'HU',
                                                  seller_city: _operator?.registered_office_city,
                                                  seller_zip: _operator?.zip_code,
                                                  seller_tax_number: _operator?.tax_number,
                                                })
                                              }}
                                              value={formData?.operator_data?.id || formData.operator_data}
                                    />
                                      {/*<InputText id="seller_name" {...input}*/}
                                      {/*           disabled*/}
                                      {/*           onChange={(e) => {*/}
                                      {/*             setFormData({*/}
                                      {/*               ...formData,*/}
                                      {/*               seller_name: e.target.value*/}
                                      {/*             })*/}
                                      {/*             setNewFormData({*/}
                                      {/*               ...newFormData,*/}
                                      {/*               seller_name: e.target.value*/}
                                      {/*             })*/}
                                      {/*           }}*/}
                                      {/*           value={formData.seller_name}*/}
                                      {/*           className={classNames({'p-invalid': isFormFieldValid(meta)})}/>*/}
                          </span>
                                    {getFormErrorMessage(meta)}
                                  </div>
                                )}/>
                              </div>
                              <div className={"p-col-12 p-lg-4"}>
                                <Field name="seller_tax_number" render={({input, meta}) => (
                                  <div className="p-field p-fluid">
                                    <HelpComponent type={"field"} field={"seller_tax_number"}/>
                                    <label htmlFor="seller_tax_number"
                                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('tax_number')}</label>
                                    <span className="p-d-block">
                            <InputText id="seller_tax_number" {...input}
                                       disabled
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           seller_tax_number: e.target.value
                                         })
                                         setNewFormData({
                                           ...newFormData,
                                           seller_tax_number: e.target.value
                                         })
                                       }}
                                       value={formData.seller_tax_number}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                                    {getFormErrorMessage(meta)}
                                  </div>
                                )}/>
                              </div>
                              <div className={"p-col-12 p-lg-2"}>
                                <Field name="seller_country_code" render={({input, meta}) => (
                                  <div className="p-field p-fluid">
                                    <HelpComponent type={"field"} field={"seller_country_code"}/>
                                    <label htmlFor="seller_country_code"
                                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('country')}</label>
                                    <span className="p-d-block">
                            <Dropdown  options={countries}
                                      disabled
                                      filter
                                      optionLabel="code"
                                      optionValue="code"
                                      id={"seller_country_code"}
                                      emptyMessage={t('empty_message')}
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          seller_country_code: e.value
                                        })
                                        setNewFormData({
                                          ...newFormData,
                                          seller_country_code: e.value
                                        })
                                      }}
                                      value={formData.seller_country_code}
                                      showClear
                            />
                          </span>
                                    {getFormErrorMessage(meta)}
                                  </div>
                                )}/>
                              </div>
                              <div className={"p-col-12 p-lg-2"}>
                                <Field name="seller_zip" render={({input, meta}) => (
                                  <div className="p-field p-fluid">
                                    <HelpComponent type={"field"} field={"seller_zip"}/>
                                    <label htmlFor="seller_zip"
                                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('zip_code')}</label>
                                    <span className="p-d-block">
                            <InputText id="seller_zip" {...input}
                                       disabled
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           seller_zip: e.target.value
                                         })
                                         setNewFormData({
                                           ...newFormData,
                                           seller_zip: e.target.value
                                         })
                                       }}
                                       value={formData.seller_zip}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                                    {getFormErrorMessage(meta)}
                                  </div>
                                )}/>
                              </div>
                              <div className={"p-col-12 p-lg-4"}>
                                <Field name="seller_city" render={({input, meta}) => (
                                  <div className="p-field p-fluid">
                                    <HelpComponent type={"field"} field={"seller_city"}/>
                                    <label htmlFor="seller_city"
                                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('city')}</label>
                                    <span className="p-d-block">
                            <InputText id="seller_city" {...input}
                                       disabled
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           seller_city: e.target.value
                                         })
                                         setNewFormData({
                                           ...newFormData,
                                           seller_city: e.target.value
                                         })
                                       }}
                                       value={formData.seller_city}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                                    {getFormErrorMessage(meta)}
                                  </div>
                                )}/>
                              </div>
                              <div className={"p-col-12 p-lg-4"}>
                                <Field name="seller_address_line1" render={({input, meta}) => (
                                  <div className="p-field p-fluid">
                                    <HelpComponent type={"field"} field={"seller_address_line1"}/>
                                    <label htmlFor="seller_address_line1"
                                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('address')}</label>
                                    <span className="p-d-block">
                            <InputText id="seller_address_line1" {...input}
                                       disabled
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           seller_address_line1: e.target.value
                                         })
                                         setNewFormData({
                                           ...newFormData,
                                           seller_address_line1: e.target.value
                                         })
                                       }}
                                       value={formData.seller_address_line1}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                                    {getFormErrorMessage(meta)}
                                  </div>
                                )}/>
                              </div>
                            </div>
                          </AccordionTab>
                        </Accordion>
                      </div>
                    </div>
                    <div className={"p-col-12 p-lg-6 col-border-left"}>
                      <div className={"p-grid"}>
                        <div className={"p-col-12 p-lg-6 p-col-align-center"}>
                          <h3 className={"p-p-0 p-mb-0 p-mt-2"}>
                            {t('buyer')}
                          </h3>
                        </div>
                        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-right"}>

                        </div>
                      </div>
                      <div className={"p-grid"}>
                        <div className={"p-col-12 p-lg-8"}>
                          <Field name="buyer_name" render={({meta}) => (
                            <div className="p-field p-fluid">
                              <HelpComponent type={"field"} field={"buyer_name"}/>
                              <label htmlFor="buyer_name"
                                     className={classNames({'p-error': isFormFieldValid(meta)})}>{t('name')}</label>
                              <span className="p-d-block">
                            <AutoComplete value={formData.buyer_name || ''}
                                          id={"buyer_name"}
                                          suggestions={partners}
                                          dropdown
                                          completeMethod={(e) => {
                                            axios({
                                              method: 'get',
                                              url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST
                                                // + "partner?direction=desc&item_per_page=20&search[name][operator]=like&search[name][value]=*"
                                                + "partner?search[full_search]=" + encodeURIComponent((e.query || '').trim()) + "&item_per_page=9999&page=1",
                                              params: {},
                                              headers: {
                                                'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                                "Sys-name": Cookies.get("instanceId"),
                                                "Preferred-locale": Cookies.get("language")
                                              }
                                            })
                                              .then(response => {
                                                setPartners((response?.data?.data?.items || []).map((partner) => ({
                                                  id: partner?.id,
                                                  name: partner?.name || '',
                                                  buyerTypeEnum: partner?.buyerTypeEnum || partner?.buyer_type_enum || null,
                                                  taxNumber: partner?.taxNumber || partner?.tax_number || '',
                                                  email: partner?.email || '',
                                                  streetAndNumber: partner?.streetAndNumber || partner?.street_and_number || '',
                                                  city: partner?.city || '',
                                                  zipCode: partner?.zipCode || partner?.zip_code || '',
                                                  country: partner?.country || null,
                                                })));
                                              })
                                              .catch(error => {
                                                setPartners([]);
                                                window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                              });
                                          }}
                                          field={"name"}
                                          delay="1000"
                                          placeholder={t('type_to_search')}
                                          onSelect={(e) => {
                                            const selectedPartnerId = e.value?.id;
                                            if (!selectedPartnerId) {
                                              return;
                                            }
                                            apiCall('get', 'partner/' + selectedPartnerId)
                                              .then((response) => {
                                                const partner = response?.data?.data || {};
                                                const updatedBuyerData = {
                                                  partner: partner?.id,
                                                  buyer_name: partner?.name || '',
                                                  buyer_type_enum: partner?.buyer_type_enum || partner?.buyerTypeEnum || null,
                                                  buyer_tax_number: partner?.tax_number || partner?.taxNumber || '',
                                                  buyer_email: partner?.email || '',
                                                  buyer_address_line1: partner?.street_and_number || partner?.streetAndNumber || '',
                                                  buyer_city: partner?.city || '',
                                                  buyer_zip: partner?.zip_code || partner?.zipCode || '',
                                                  buyer_country_code: partner?.country || null,
                                                };
                                                setFormData((prevState) => ({
                                                  ...prevState,
                                                  ...updatedBuyerData,
                                                }));
                                                setNewFormData((prevState) => ({
                                                  ...prevState,
                                                  ...updatedBuyerData,
                                                }));
                                              })
                                              .catch((error) => {
                                                window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                              });
                                          }}
                                          onChange={(e) => {
                                            const buyerNameValue = typeof e.value === 'string'
                                              ? e.value
                                              : (e.value?.name || '');
                                            setFormData((prevState) => ({
                                              ...prevState,
                                              buyer_name: buyerNameValue
                                            }))
                                            setNewFormData((prevState) => ({
                                              ...prevState,
                                              buyer_name: buyerNameValue
                                            }))
                                          }}
                                          className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                              {getFormErrorMessage(meta)}
                            </div>
                          )}/>
                        </div>
                        <div className={"p-col-12 p-lg-4"}>
                          <Field name="buyer_type_enum" render={({input, meta}) => (
                            <div className="p-field p-fluid">
                              <HelpComponent type={"field"} field={"buyer_type_enum"}/>
                              <label htmlFor="buyer_type_enum"
                                     className={classNames({'p-error': isFormFieldValid(meta)})}>{t('buyer_type')}</label>
                              <span className="p-d-block">
                      <Dropdown  options={buyerTypes}
                                filter
                                optionLabel={(option) => window.App.getTranslatedLabel(option.key)}
                                optionValue="value"
                                id={"buyer_type_enum"}
                                emptyMessage={t('empty_message')}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    buyer_type_enum: e.value
                                  })
                                  setNewFormData({
                                    ...newFormData,
                                    buyer_type_enum: e.value
                                  })
                                }}
                                value={formData.buyer_type_enum}
                                showClear
                      />
                    </span>
                              {getFormErrorMessage(meta)}
                            </div>
                          )}/>
                        </div>
                        <div className={"p-col-12 p-lg-2"}>
                          <Field name="buyer_country_code" render={({input, meta}) => (
                            <div className="p-field p-fluid">
                              <HelpComponent type={"field"} field={"buyer_country_code"}/>
                              <label htmlFor="buyer_country_code"
                                     className={classNames({'p-error': isFormFieldValid(meta)})}>{t('country')}</label>
                              <span className="p-d-block">
                      <Dropdown  options={countries}
                                filter
                                optionLabel="code"
                                optionValue="code"
                                id={"buyer_country_code"}
                                emptyMessage={t('empty_message')}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    buyer_country_code: e.value
                                  })
                                  setNewFormData({
                                    ...newFormData,
                                    buyer_country_code: e.value
                                  })
                                }}
                                value={formData.buyer_country_code}
                                showClear
                      />
                    </span>
                              {getFormErrorMessage(meta)}
                            </div>
                          )}/>
                        </div>
                        <div className={"p-col-12 p-lg-2"}>
                          <Field name="buyer_zip" render={({input, meta}) => (
                            <div className="p-field p-fluid">
                              <HelpComponent type={"field"} field={"buyer_zip"}/>
                              <label htmlFor="buyer_zip"
                                     className={classNames({'p-error': isFormFieldValid(meta)})}>{t('zip_code')}</label>
                              <span className="p-d-block">
                            <InputText id="buyer_zip" {...input}
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           buyer_zip: e.target.value
                                         })
                                         setNewFormData({
                                           ...newFormData,
                                           buyer_zip: e.target.value
                                         })
                                         if (e.target.value.length >= 4) {
                                           window.App.zipCode(e.target.value, (city) => {
                                             setFormData(prev => ({
                                               ...prev,
                                               buyer_city: city
                                             }));
                                             setNewFormData(prev => ({
                                               ...prev,
                                               buyer_city: city
                                             }));
                                           });
                                         }
                                       }}
                                       value={formData.buyer_zip}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                              {getFormErrorMessage(meta)}
                            </div>
                          )}/>
                        </div>
                        <div className={"p-col-12 p-lg-4"}>
                          <Field name="buyer_city" render={({input, meta}) => (
                            <div className="p-field p-fluid">
                              <HelpComponent type={"field"} field={"buyer_city"}/>
                              <label htmlFor="buyer_city"
                                     className={classNames({'p-error': isFormFieldValid(meta)})}>{t('city')}</label>
                              <span className="p-d-block">
                            <InputText id="buyer_city" {...input}
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           buyer_city: e.target.value
                                         })
                                         setNewFormData({
                                           ...newFormData,
                                           buyer_city: e.target.value
                                         })
                                       }}
                                       value={formData.buyer_city}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                              {getFormErrorMessage(meta)}
                            </div>
                          )}/>
                        </div>
                        <div className={"p-col-12 p-lg-4"}>
                          <Field name="buyer_address_line1" render={({input, meta}) => (
                            <div className="p-field p-fluid">
                              <HelpComponent type={"field"} field={"buyer_address_line1"}/>
                              <label htmlFor="buyer_address_line1"
                                     className={classNames({'p-error': isFormFieldValid(meta)})}>{t('address')}</label>
                              <span className="p-d-block">
                            <InputText id="buyer_address_line1" {...input}
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           buyer_address_line1: e.target.value
                                         })
                                         setNewFormData({
                                           ...newFormData,
                                           buyer_address_line1: e.target.value
                                         })
                                       }}
                                       value={formData.buyer_address_line1}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                              {getFormErrorMessage(meta)}
                            </div>
                          )}/>
                        </div>
                        <div className={"p-col-12 p-lg-8"}>
                          <Field name="buyer_email" render={({input, meta}) => (
                            <div className="p-field p-fluid">
                              <HelpComponent type={"field"} field={"seller_tax_number"}/>
                              <label htmlFor="buyer_email"
                                     className={classNames({'p-error': isFormFieldValid(meta)})}>{t('email')}</label>
                              <span className="p-d-block">
                            <InputText id="buyer_email" {...input}
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           buyer_email: e.target.value
                                         })
                                         setNewFormData({
                                           ...newFormData,
                                           buyer_email: e.target.value
                                         })
                                       }}
                                       value={formData.buyer_email}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                              {getFormErrorMessage(meta)}
                            </div>
                          )}/>
                        </div>
                        {formData.buyer_type_enum === 'company' &&
                          <div className={"p-col-12 p-lg-4"}>
                            <Field name="buyer_tax_number" render={({input, meta}) => (
                              <div className="p-field p-fluid">
                                <HelpComponent type={"field"} field={"buyer_tax_number"}/>
                                <label htmlFor="buyer_tax_number"
                                       className={classNames({'p-error': isFormFieldValid(meta)})}>{t('tax_number')}</label>
                                <span className="p-d-block">
                            <InputText id="buyer_tax_number" {...input}
                                       onChange={(e) => {
                                         setFormData({
                                           ...formData,
                                           buyer_tax_number: e.target.value
                                         })
                                         setNewFormData({
                                           ...newFormData,
                                           buyer_tax_number: e.target.value
                                         })
                                       }}
                                       value={formData.buyer_tax_number}
                                       className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                          </span>
                                {getFormErrorMessage(meta)}
                              </div>
                            )}/>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </Panel>
                <Panel className={"p-mt-3"}>
                  <h3 className={"p-mt-0"}>
                    {t('receipt_items')}
                  </h3>
                  <table className={"w-100 p-datatable-table table-striped"} cellPadding={0} cellSpacing={0}
                         border={0}>
                    <thead>
                    <tr>
                      <th className={"p-p-2 p-text-nowrap p-text-left"}>{t('name')}</th>
                      <th className={"p-p-2 p-text-nowrap p-text-right"}>{t('quantity')}</th>
                      <th className={"p-p-2 p-text-nowrap p-text-left"}>{t('unit')}</th>
                      <th className={"p-p-2 p-text-nowrap p-text-right"}>{t('unit_net_amount')}</th>
                      <th className={"p-p-2 p-text-nowrap p-text-left"}>{t('vat_percent')}</th>
                      <th className={"p-p-2 p-text-nowrap p-text-right"}>{t('net_amount')}</th>
                      <th className={"p-p-2 p-text-nowrap p-text-right"}>{t('tot_price')}</th>
                      <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {formData.items && formData.items[0] ? (
                      <>
                        {formData.items.map((item, index) => {
                          return (
                            <tr>
                              <td className={"p-text-left p-text-nowrap"}>
                                {item.name}
                              </td>
                              <td className={"p-text-right p-text-nowrap"}>
                                {formatQuantity(item?.quantity)}
                              </td>
                              <td className={"p-text-left p-text-nowrap"}>
                                {item.unit}
                              </td>
                              <td className={"p-text-right p-text-nowrap"}>
                                {currencyFormatter.format(
                                  item.unit_net_amount, {
                                    precision: t('currency_precision'),
                                    symbol: t('currency_symbol'),
                                    decimal: t('currency_decimal'),
                                    thousand: t('currency_thousand'),
                                  }
                                )} {formData?.currency}
                              </td>
                              <td className={"p-text-left p-text-nowrap"}>
                                {item.vat_percent} %
                              </td>
                              <td className={"p-text-right p-text-nowrap"}>
                                {currencyFormatter.format(
                                  item.net_amount || item.unit_net_amount * item.quantity, {
                                    precision: t('currency_precision'),
                                    symbol: t('currency_symbol'),
                                    decimal: t('currency_decimal'),
                                    thousand: t('currency_thousand'),
                                  }
                                )} {formData?.currency}
                              </td>
                              <td className={"p-text-right p-text-nowrap p-text-bold"}>
                                {currencyFormatter.format(
                                  (item.gross_amount || item.unit_net_amount * item.quantity * (1 + item.vat_percent / 100)), {
                                    precision: t('currency_precision'),
                                    symbol: t('currency_symbol'),
                                    decimal: t('currency_decimal'),
                                    thousand: t('currency_thousand'),
                                  }
                                )} {formData?.currency}
                              </td>
                              <td className={"p-text-right"}>
                                <Button type="button" aria-label={t('delete')}
                                        icon={"pi pi-trash"}
                                        onClick={() => {
                                          const updatedItems = [...formData.items];
                                          updatedItems.splice(index, 1);
                                          setFormData({
                                            ...formData,
                                            items: updatedItems
                                          });
                                          setNewFormData({
                                            ...newFormData,
                                            items: updatedItems
                                          });
                                          if (entity === 'receipt' || window.App.urlVars().create == 'invoice') {
                                            document.getElementById('folio-item' + item.id).classList.remove('folio-item-oninvoice-true')
                                          }
                                        }}
                                        className="p-button-danger p-button-sm p-ml-2">
                                </Button>
                                {window.location.hash.toString().includes('#/receipt') &&
                                  <Button type="button" aria-label={t('edit')}
                                          icon={"pi pi-pencil"}
                                          onClick={() => {
                                            setItemFormData(item)
                                            if (entity === 'receipt') {
                                              if (action === 'create') {
                                                navigate('/receipt/' + action + '?update=receiptItem')
                                              }
                                              if (action === 'update') {
                                                navigate('/receipt/' + action + '/' + id + '?update=receiptItem')
                                              }
                                            }
                                            if (window.location.hash.toString().includes('#/folio')) {
                                              let _params = '?'
                                              Object.entries(window.App.urlVars()).map(([key, value]) => {
                                                _params += key + '=' + value + '&'
                                              })
                                              _params += 'update=receiptItem'
                                              navigate('/folio/manage' + _params)
                                            }
                                            if (window.location.hash.toString().includes('#/reservation')) {
                                              let _params = '?'
                                              Object.entries(window.App.urlVars()).map(([key, value]) => {
                                                _params += key + '=' + value + '&'
                                              })
                                              _params += 'update=receiptItem'
                                              navigate('/reservation/' + action + '/' + id + _params)
                                            }
                                          }}
                                          className="p-button-warning p-button-sm p-ml-2">
                                  </Button>
                                }
                              </td>
                            </tr>
                          )
                        })}
                      </>
                    ) : (
                      <tr>
                        <td colSpan={8}>
                          {t('empty_message')}
                        </td>
                      </tr>
                    )}
                    </tbody>
                    {formData.items && formData.items[0] &&
                      <tfoot>
                      <tr>
                        <th colSpan={5} className={"p-p-2 p-text-nowrap p-text-right"}>
                          {t('total')}:
                        </th>
                        <th className={"p-p-2 p-text-nowrap p-text-right"}>
                          {(() => {
                            let total = 0;
                            if (formData.items && formData.items[0]) {
                              formData.items.map((item) => {
                                total = total + Number(item.unit_net_amount * item.quantity)
                              })
                            }
                            return (
                              currencyFormatter.format(
                                total, {
                                  precision: t('currency_precision'),
                                  symbol: t('currency_symbol'),
                                  decimal: t('currency_decimal'),
                                  thousand: t('currency_thousand'),
                                })

                            )
                          })()} {formData?.currency}
                        </th>
                        <th className={"p-p-2 p-text-nowrap p-text-right"}>
                          {(() => {
                            let total = 0;
                            if (formData.items && formData.items[0]) {
                              formData.items.map((item) => {
                                total = total + Number(item.unit_net_amount * item.quantity * (1 + item.vat_percent / 100))
                              })
                            }
                            return (
                              currencyFormatter.format(
                                total, {
                                  precision: t('currency_precision'),
                                  symbol: t('currency_symbol'),
                                  decimal: t('currency_decimal'),
                                  thousand: t('currency_thousand'),
                                })
                            )
                          })()} {formData?.currency}
                        </th>
                        <td></td>
                      </tr>
                      </tfoot>
                    }
                  </table>
                  <div className={"p-grid p-mt-1"}>
                    <div className={"p-col-12 p-text-right p-col-align-center"}>
                      {/*<Button type="button" label={t('add_receipt_item')}*/}
                      {/*        icon={"pi pi-plus"}*/}
                      {/*        onClick={() => {*/}
                      {/*          setItemFormData({})*/}
                      {/*          if (entity === 'receipt') {*/}
                      {/*            if (action === 'create') {*/}
                      {/*              navigate('/receipt/' + action + '?create=receiptItem')*/}
                      {/*            }*/}
                      {/*            if (action === 'update') {*/}
                      {/*              navigate('/receipt/' + action + '/' + id + '?create=receiptItem')*/}
                      {/*            }*/}
                      {/*          }*/}
                      {/*          if (window.location.hash.toString().includes('#/folio')) {*/}
                      {/*            let _params = '?'*/}
                      {/*            Object.entries(urlVars).map(([key, value]) => {*/}
                      {/*              _params += key + '=' + value + '&'*/}
                      {/*            })*/}
                      {/*            _params += 'add=receiptItem'*/}
                      {/*            navigate('/folio/manage' + _params)*/}
                      {/*          }*/}
                      {/*        }}*/}
                      {/*        className="p-button-success p-button-sm p-ml-2">*/}
                      {/*</Button>*/}
                    </div>
                  </div>
                </Panel>
                <Dialog header={t('receipt_item')}
                        footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}}
                                                         severity="info" text={t("dialog_movable")}/></React.Fragment>}
                        visible={window.App.urlVars().create === 'receiptItem' || window.App.urlVars().update === 'receiptItem' || window.App.urlVars().add === 'receiptItem'}
                        style={{minWidth: '980px', width: '980px', maxWidth: '980px'}}
                        onHide={() => {
                          setSelectedItem('')
                          setItemFormData({})
                          if (entity === 'receipt') {
                            if (action === 'create') {
                              navigate('/receipt/' + action)
                            }
                            if (action === 'update') {
                              navigate('/receipt/' + action + '/' + id)
                            }
                          }
                          if (window.location.hash.toString().includes('#/folio')) {
                            navigate(-1)
                          }
                          if (window.location.hash.toString().includes('#/reservation')) {
                            navigate(-1)
                          }
                          if (window.location.hash.toString().includes('#/receipt')) {
                            navigate(-1)
                          }
                        }} modal={false}>
                  <Panel className={"p-mt-3"}>
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6"}>
                        <Field name="name" render={({input, meta}) => (
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"name"}/>
                            <label htmlFor="Receiptitem_code"
                                   className={classNames({'p-error': isFormFieldValid(meta)})}>{t('name')}</label>
                            <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setItemFormData({
                                     ...itemFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={itemFormData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                            {getFormErrorMessage(meta)}
                          </div>
                        )}/>
                      </div>
                      <div className={"p-col-12 p-lg-1"}>
                        <Field name="quantity" render={({input, meta}) => (
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"quantity"}/>
                            <label htmlFor="quantity"
                                   className={classNames({'p-error': isFormFieldValid(meta)})}>{t('quantity')}</label>
                            <span className="p-d-block">
                      <InputText id="quantity" {...input}
                                 keyfilter={"num"}
                                 onChange={(e) => {
                                   setItemFormData({
                                     ...itemFormData,
                                     quantity: e.target.value
                                   })
                                 }}
                                 value={itemFormData.quantity}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                            {getFormErrorMessage(meta)}
                          </div>
                        )}/>
                      </div>
                      <div className={"p-col-12 p-lg-2"}>
                        <Field name="unit" render={({input, meta}) => (
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"unit"}/>
                            <label htmlFor="unit"
                                   className={classNames({'p-error': isFormFieldValid(meta)})}>{t('unit')}</label>
                            <span className="p-d-block">
                        <Dropdown  options={units}
                                  filter
                                  optionLabel={(option) => window.App.getTranslatedLabel(option.value)}
                                  optionValue="value"
                                  id={"unit"}
                                  emptyMessage={t('empty_message')}
                                  onChange={(e) => {
                                    setItemFormData({
                                      ...itemFormData,
                                      unit: e.value,
                                    })
                                  }}
                                  value={itemFormData.unit}
                        />
                    </span>
                            {getFormErrorMessage(meta)}
                          </div>
                        )}/>
                      </div>
                      <div className={"p-col-12 p-lg-2"}>
                        <Field name="unit_net_amount" render={({input, meta}) => (
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"unit_net_amount"}/>
                            <label htmlFor="unit_net_amount"
                                   className={classNames({'p-error': isFormFieldValid(meta)})}>{t('net_amount')}</label>
                            <span className="p-d-block">
                      <InputText id="unit_net_amount" {...input}
                                 keyfilter={"num"}
                                 onChange={(e) => {
                                   setItemFormData({
                                     ...itemFormData,
                                     unit_net_amount: e.target.value
                                   })
                                 }}
                                 value={itemFormData.unit_net_amount}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                            {getFormErrorMessage(meta)}
                          </div>
                        )}/>
                      </div>
                      <div className={"p-col-12 p-lg-1"}>
                        <Field name="vat_percent" render={({input, meta}) => (
                          <div className="p-field p-fluid">
                            <HelpComponent type={"field"} field={"vat_percent"}/>
                            <label htmlFor="vat_percent"
                                   className={classNames({'p-error': isFormFieldValid(meta)})}>{t('vat_percent')}</label>
                            <span className="p-d-block">
                        <Dropdown  options={vatPercents}
                                  filter
                                  optionLabel="vat_percent"
                                  optionValue="vat_percent"
                                  id={"vat_percent"}
                                  emptyMessage={t('empty_message')}
                                  onChange={(e) => {
                                    setItemFormData({
                                      ...itemFormData,
                                      vat_percent: e.value,
                                    })
                                  }}
                                  value={itemFormData.vat_percent}
                        />
                    </span>
                            {getFormErrorMessage(meta)}
                          </div>
                        )}/>
                      </div>
                    </div>
                    <div className={"p-grid"}>
                      <div className={"p-col"}>
                      </div>
                      <div className={"p-col p-text-right p-col-align-center"}>
                        <Button type="button" aria-label={t('add')} icon={"pi pi-plus"}
                                label={t('add')}
                                disabled={!itemFormData.name || !itemFormData.quantity || !itemFormData.unit || !itemFormData.vat_percent}
                                loading={loading}
                                onClick={() => {
                                  if (selectedItem) {
                                    document.getElementById('folio-item' + selectedItem).classList.add('folio-item-oninvoice-true')
                                  }
                                  if ((itemFormData.id && !window.App.urlVars().folioItemId) || window.App.urlVars().update === 'receiptItem') {
                                    const itemIndex = formData.items.findIndex(item => item.id === itemFormData.id);
                                    if (itemIndex !== -1) {
                                      const updatedItems = [...formData.items];
                                      updatedItems[itemIndex] = {
                                        ...updatedItems[itemIndex], // Keep existing properties
                                        ...itemFormData             // Overwrite with updated ones
                                      };
                                      setFormData({
                                        ...formData,
                                        items: updatedItems
                                      });
                                      setNewFormData({
                                        ...newFormData,
                                        items: updatedItems
                                      });
                                    }
                                  } else {
                                    setFormData({
                                      ...formData,
                                      items: [...formData.items, itemFormData]
                                    })
                                    setNewFormData({
                                      ...newFormData,
                                      items: [...formData.items, itemFormData]
                                    })
                                  }
                                  if (window.location.hash.toString().includes('#/folio')) {
                                    navigate(-1)
                                  }
                                  if (window.location.hash.toString().includes('#/reservation')) {
                                    navigate(-1)
                                  }
                                  if (window.location.hash.toString().includes('#/receipt')) {
                                    navigate(-1)
                                  }
                                }}
                                className="p-button-success p-ml-2"/>
                      </div>
                    </div>
                  </Panel>
                </Dialog>
              </form>
            )}/>
          </BlockUI>
          {/*<div className={"p-grid p-mt-1"}>*/}
          {/*  <div className={"p-col-12 p-text-right p-col-align-center"}>*/}
          {/*    {formData?.type === 'proforma' && formData?.status === 'issued' && formData?.paid_at && formData?.paid_at === null ? (*/}
          {/*      <Button icon="pi pi-check" className="p-button-success p-ml-2"*/}
          {/*              label={t('mark_as_paid')}*/}
          {/*              loading={loading}*/}
          {/*              onClick={() => {*/}
          {/*                axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "invoice/" + formData.id + "/mark-paid",*/}
          {/*                  {},*/}
          {/*                  {*/}
          {/*                    params: {},*/}
          {/*                    headers: {*/}
          {/*                      'Authorization': 'Bearer ' + Cookies.get("userToken"),*/}
          {/*                      "Sys-name": Cookies.get("instanceId"),*/}
          {/*                      "Preferred-locale": Cookies.get("language"),*/}
          {/*                      'Content-Type': 'multipart/form-data'*/}
          {/*                    }*/}
          {/*                  })*/}
          {/*                  .then(response => {*/}
          {/*                    window.App.setState({*/}
          {/*                      rerenderReceiptList: Math.random(),*/}
          {/*                    })*/}
          {/*                  })*/}
          {/*                  .catch(error => {*/}
          {/*                    window.App.toastShow('error', t('error'), error.toString(), '', error.response);*/}
          {/*                  })*/}
          {/*              }}*/}
          {/*      />*/}
          {/*    ):(*/}
          {/*      <Button icon="pi pi-check" className="p-button-success p-ml-2"*/}
          {/*              label={t('mark_as_paid')}*/}
          {/*              disabled*/}
          {/*      />*/}
          {/*    )}*/}
          {/*    {formData?.billing_integration && formData?.billing_integration !== 'none' ? (*/}
          {/*      <Button icon="pi pi-download" className="p-button-md p-button-secondary p-ml-2"*/}
          {/*              label={t('download')}*/}
          {/*              disabled={!formData.pdf_url}*/}
          {/*              loading={loading}*/}
          {/*              onClick={() => {*/}
          {/*                if (formData?.billing_integration === 'Billingo') {*/}
          {/*                  window.open(formData.pdf_url, '_blank', 'noopener,noreferrer');*/}
          {/*                }*/}
          {/*                if (formData?.billing_integration === 'számlázz.hu') {*/}
          {/*                  axios.get(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + 'billing/invoice/' + formData.id + '/download-pdf',*/}
          {/*                    {*/}
          {/*                      responseType: 'blob',*/}
          {/*                      params: {},*/}
          {/*                      headers: {*/}
          {/*                        'Authorization': 'Bearer ' + Cookies.get("userToken"),*/}
          {/*                        "Sys-name": Cookies.get("instanceId"),*/}
          {/*                        "Preferred-locale": Cookies.get("language"),*/}
          {/*                      }*/}
          {/*                    })*/}
          {/*                    .then(response => {*/}
          {/*                      window.App.toastShow('success', t('success'), response.data.message)*/}
          {/*                      download(response.data, formData.third_party_service_id + '.pdf')*/}
          {/*                    })*/}
          {/*                    .catch(error => {*/}
          {/*                      window.App.toastShow('error', t('error'), error.toString(), '', error.response);*/}
          {/*                    })*/}
          {/*                }*/}
          {/*              }}*/}
          {/*      />*/}
          {/*    ) : (*/}
          {/*      <Button icon="pi pi-download" className="p-button-md p-button-secondary p-ml-2"*/}
          {/*              label={t('download')}*/}
          {/*              disabled*/}
          {/*              loading={loading}*/}
          {/*      />*/}
          {/*    )}*/}
          {/*    {formData.id && formData.status === 'draft' && formData.items && formData.items[0] ? (*/}
          {/*      <Button icon="pi pi-sync" className="p-button-md p-button-success p-ml-2"*/}
          {/*              label={t('sync_receipt_and_save')}*/}
          {/*              loading={loading}*/}
          {/*              disabled={!formData.billing_integration || formData.billing_integration?.length == 0}*/}
          {/*              onClick={() => {*/}
          {/*                if (formData?.billing_integration === 'számlázz.hu') {*/}
          {/*                  setLoading(true);*/}
          {/*                  axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "billing/invoice/" + formData.id + "/sync-szamlazzhu",*/}
          {/*                    formData,*/}
          {/*                    {*/}
          {/*                      params: {},*/}
          {/*                      headers: {*/}
          {/*                        'Authorization': 'Bearer ' + Cookies.get("userToken"),*/}
          {/*                        "Sys-name": Cookies.get("instanceId"),*/}
          {/*                        "Preferred-locale": Cookies.get("language")*/}
          {/*                      }*/}
          {/*                    })*/}
          {/*                    .then(response => {*/}
          {/*                      window.App.toastShow('success', t('success'), response.data.message)*/}
          {/*                      window.App.setState({*/}
          {/*                        rerenderReceiptList: Math.random(),*/}
          {/*                        rerenderFolioList: Math.random(),*/}
          {/*                      })*/}
          {/*                      apiCall('get', 'invoice/' + formData.id)*/}
          {/*                        .then(response => {*/}
          {/*                          setLoading(false)*/}
          {/*                          setFormData(response.data.data);*/}
          {/*                          if (response.data && response.data.data && response.data.data.under_edit_from && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {*/}
          {/*                            setLocking(true)*/}
          {/*                          }*/}
          {/*                          navigate(-1)*/}
          {/*                        })*/}
          {/*                        .catch(error => {*/}
          {/*                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);*/}
          {/*                          setLoading(false)*/}
          {/*                        })*/}
          {/*                    })*/}
          {/*                    .catch(error => {*/}
          {/*                      window.App.toastShow('error', t('error'), error.toString(), '', error.response);*/}
          {/*                      setLoading(false)*/}
          {/*                    })*/}
          {/*                }*/}
          {/*                if (formData?.billing_integration === 'Billingo') {*/}
          {/*                  setLoading(true);*/}
          {/*                  axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "billing/invoice/" + formData.id + "/sync-billingo",*/}
          {/*                    formData,*/}
          {/*                    {*/}
          {/*                      params: {},*/}
          {/*                      headers: {*/}
          {/*                        'Authorization': 'Bearer ' + Cookies.get("userToken"),*/}
          {/*                        "Sys-name": Cookies.get("instanceId"),*/}
          {/*                        "Preferred-locale": Cookies.get("language")*/}
          {/*                      }*/}
          {/*                    })*/}
          {/*                    .then(response => {*/}
          {/*                      window.App.toastShow('success', t('success'), response.data.message)*/}
          {/*                      window.App.setState({*/}
          {/*                        rerenderReceiptList: Math.random(),*/}
          {/*                        rerenderFolioList: Math.random(),*/}
          {/*                      })*/}
          {/*                      apiCall('get', 'invoice/' + formData.id)*/}
          {/*                        .then(response => {*/}
          {/*                          setLoading(false)*/}
          {/*                          setFormData(response.data.data);*/}
          {/*                          if (response.data && response.data.data && response.data.data.under_edit_from && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {*/}
          {/*                            setLocking(true)*/}
          {/*                          }*/}
          {/*                        })*/}
          {/*                        .catch(error => {*/}
          {/*                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);*/}
          {/*                          setLoading(false)*/}
          {/*                        })*/}
          {/*                    })*/}
          {/*                    .catch(error => {*/}
          {/*                      window.App.toastShow('error', t('error'), error.toString(), '', error.response);*/}
          {/*                      setLoading(false)*/}
          {/*                    })*/}
          {/*                }*/}
          {/*              }}*/}
          {/*      />*/}
          {/*    ) : (*/}
          {/*      <Button icon="pi pi-sync" className="p-button-md p-button-success p-ml-2 disabled"*/}
          {/*              label={t('sync_receipt_and_save')}*/}
          {/*              loading={loading}*/}
          {/*              onClick={() => {*/}
          {/*                //window.App.customToastShow('warn', t('warning'), t('sync_receipt_not_available'));*/}
          {/*              }}*/}
          {/*      />*/}
          {/*    )}*/}
          {/*  </div>*/}
          {/*</div>*/}
          {locking === true &&
            <div className={"p-mt-2"}>
              <i className={"pi pi-exclamation-circle"}></i>
              &nbsp;
              {t('form_under_edit')}
              {formData && formData.under_edit_by_name_snap &&
                <>&nbsp;{t('form_under_edit_by')}: {formData.under_edit_by_name_snap}</>
              }
            </div>
          }
        </div>
      </div>

    </div>
  )
}
export default withTranslation('common')(_FM_ReceiptFormComponent);
